function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Power_grid"
}, /*#__PURE__*/React.createElement("title", null, "VF_power_grid_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M283.4 134.7v-14.2h-96.6l-16.2-77.9h42V78H241V35.5h-.1V14.2H42.5V78h28.3V42.6h42l-16.2 77.9H0v56.7h28.3v-28.3h62.4l-25 120.4h28.9l7.4-35.4h79.5l7.4 35.4h29l-25.1-120.4h62.4v28.3h28.3l-.1-42.5zM141.7 42.9l16.1 77.5h-32.3l16.2-77.5zm33.9 162.6h-67.7l11.8-56.6h44.1l11.8 56.6z"
}))));